import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiEndpointConfigService {
  baseApiUrl = '';
  brightStarUrl = '';
  buyflowApiBaseUrl = '';
  genesisApiUrl = '';
  msapiBaseUrl = '';
  orderMsApiEndpoint = '';
  saleReserveUrl = '';
  oneClickPpcUrl = '';
  algoliaConfig = {
    url: '',
    appId: '',
    apiKey: '',
  };
}
